import { type TFunction } from 'i18next';

import { alertDialog } from '@/ui_v3';

export type ImageSearchFailure = 'rate_limited' | 'failed';

// pexels/naver 검색 실패 시 공통으로 띄우는 다이얼로그.
export const openImageSearchFailDialog = (
  t: TFunction<['build', 'common']>,
  failure: ImageSearchFailure,
) =>
  alertDialog.open({
    header: {
      title: t('build:image.searchTab.failTitle'),
    },
    body:
      failure === 'rate_limited'
        ? t('build:build.actionError.waitTry')
        : t('build:image.searchTab.failDescription'),
    confirmText: t('common:common.alertDialog.confirmText'),
  });
